import {
  Card,
  Title,
  Stack,
  Group,
  Image,
  Box,
  ThemeIcon,
  SimpleGrid,
  Text,
} from "@mantine/core";
import { IconCalendar, IconMapPin } from "@tabler/icons-react";
import LanguageSwitcher from "../LanguageSwitcher";
import { useTranslation } from "react-i18next";
import { getTranslatedMonth } from "@congrs/utils";

function EventHeader({ event, eventDates, showDetails = true }) {
  const { t } = useTranslation();
  const formatDate = (date) =>
    `${getTranslatedMonth(date, t)} ${new Date(date).getDate()}, ${new Date(date).getFullYear()}`;

  const dateRange =
    eventDates?.length === 1
      ? formatDate(eventDates[0].date)
      : eventDates?.length > 1
        ? `${formatDate(eventDates[0].date)} - ${formatDate(eventDates[eventDates.length - 1].date)}`
        : "";

  const InfoCard = ({ icon, label, value }) => (
    <Box
      p="md"
      style={{
        backgroundColor: "rgba(255, 255, 255, 0.6)",
        borderRadius: "12px",
        border: "1px solid rgba(0, 0, 0, 0.08)",
      }}
    >
      <Group gap="sm" wrap="nowrap">
        <ThemeIcon size="lg" radius="md" variant="light">
          {icon}
        </ThemeIcon>
        <Box style={{ flex: 1 }}>
          <Text size="xs" c="dimmed" fw={500} tt="uppercase">
            {label}
          </Text>
          <Text size="sm" fw={600} mt={2}>
            {value}
          </Text>
        </Box>
      </Group>
    </Box>
  );

  return (
    <Card shadow="lg" p={0} radius="md" withBorder mb="xl">
      <Box
        p="xl"
        style={{
          background:
            "linear-gradient(135deg, rgba(0, 0, 0, 0.03) 0%, rgba(0, 0, 0, 0.01) 100%)",
        }}
      >
        <Stack gap="lg">
          <Group align="center" gap="lg" style={{ width: "100%" }}>
            {event?.logoImage && (
              <Image
                src={event.logoImage}
                alt={`${event?.name} Logo`}
                w={80}
                h={80}
                fit="contain"
                radius="lg"
                style={{ border: "2px solid rgba(255, 255, 255, 0.8)" }}
              />
            )}
            <Title order={1} size="h1" style={{ flex: 1 }}>
              {event?.name || "Event Registration"}
            </Title>
            <LanguageSwitcher
              event={event}
              triggerStyle={{
                backgroundColor: "#f1f3f5",
                border: "1px solid #dee2e6",
                color: "#495057",
              }}
              dropdownStyle={{
                backgroundColor: "#f1f3f5",
                border: "1px solid #dee2e6",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
              }}
              itemStyle={{
                color: "#495057",
                backgroundColor: "transparent",
              }}
            />
          </Group>

          {showDetails && (
            <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
              {eventDates?.length > 0 && (
                <InfoCard
                  icon={<IconCalendar size={20} />}
                  label={t("event_date")}
                  value={dateRange}
                />
              )}

              {event?.mainLocation && (
                <InfoCard
                  icon={<IconMapPin size={20} />}
                  label={t("location")}
                  value={event.mainLocation}
                />
              )}
            </SimpleGrid>
          )}
        </Stack>
      </Box>
    </Card>
  );
}

export default EventHeader;
